<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">people</v-icon>
          Customers
        </h3>
        Here you can change/add your customers.
        <blockquote>
          Please use the edit or add buttons to configure your customers.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-5 elevation-3>
      <v-flex xs12>
        <customer-list></customer-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerList from "@/components/CustomerList.vue";

export default {
  components: {
    CustomerList
  }
};
</script>
